import { GridApi} from "ag-grid-community";
import {action, IObservableValue, makeObservable, observable} from "mobx";
import {MLanguageFiles} from "@elte/translate-backend/interface/lang_file";
import TLanguageFile = MLanguageFiles.TLanguageFile;


export class ConfirmTranslateStore {
    gridApi: GridApi = null;

    constructor() {
        makeObservable(this);
    }

    @observable acceptedUserId: string = "";
    @observable userLogin:string = "";
    @observable languageToAccept: string =''
    @observable lastModified: Date = null
    @observable openAccept: boolean = false;
    usersTranslationTarget:IObservableValue<TLanguageFile> = observable.box(null,{deep:false});
    @observable fileId: string = ''

    @action
    clear() {
        this.languageToAccept = ''
        this.acceptedUserId = ''
        this.fileId = ''
        this.usersTranslationTarget.set(null);
    }

    @action
    handleOpenAccept () {
        this.openAccept = !this.openAccept
    }

    @action
    handleCloseAccept ()  {
        this.openAccept = false
    };

    @action
    clearView() {
        this.usersTranslationTarget.set(null)
        this.languageToAccept = ''
    }


}
